module.exports = __webpack_public_path__ + "static/media/notif-join-us.5633344a.jpg";